<script>
  import DashboardNotasFrequencias from './NotasFrequencias'
  import DashboardHorarios from './Horarios'
  import DashboardNovidades from './Novidades'
  import DashboardQualificacaoUrcamp from './QualificacaoUrcamp'
  import DashboardBoxLink from './BoxLink'
  import DashboardPopup from './popup/Main'
  import DashboardVideoPopup from './popup/VideoPopup'
  import DashboardGraduacaoIPopup from './popup/GraduacaoIPopup'
  import DashboardGraduacaoICppPopup from './popup/GraduacaoICppPopup'
  import DashboardMatriculaOnline from './matricula_online/Index'
  import DashboardPreMatriculadoPopup from './popup/PreMatriculadoPopup'
  
  import * as restfulService from '../../services/restfulService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters} from 'vuex'
  import swal from 'sweetalert2'
  import DashboardValidaMeusDadosPopup from './popup/ValidaMeusDadosPopup'

  export default {
    components: {
      DashboardValidaMeusDadosPopup,
      DashboardNotasFrequencias,
      DashboardHorarios,
      DashboardNovidades,
      DashboardQualificacaoUrcamp,
      DashboardBoxLink,
      DashboardPopup,
      DashboardVideoPopup,
      DashboardGraduacaoIPopup,
      DashboardGraduacaoICppPopup,
      DashboardMatriculaOnline,
      DashboardPreMatriculadoPopup
    },
    mixins: [helpers],
    data () {
      return {
        mostrarModalEnsinoHibrido: false,
        exibeBannerMatricula: false,
        mostrarModalAmbientesVirtuais: false
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'isLogged']),
      isMobileSize: function () {
        return this.isMobile().any()
      },
      professor: function () {
        if (!this.isLogged) {
          return false
        }
        return this.currentUser.pessoa ? (this.currentUser.pessoa.perfil_professor || false) : false
      },
      soEnsinoBasico: function () {
        return this.currentUser.so_ensino_basico || false
      }
    },
    mounted () {
      bus.$emit('hide-loader')
      restfulService.get('matricula-online/exibe-banner-matricula')
        .then(response => {
          if (!response.error) {
            this.exibeBannerMatricula = true
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    methods: {
      abrirModalEnsinoHibrido () {
        this.mostrarModalEnsinoHibrido = true
      },
      abrirModalAmbientesVirtuais () {
        this.mostrarModalAmbientesVirtuais = true
      },
      logarMoodle () {
        bus.$emit('show-loader')
        restfulService.get('usuario', 'moodle-login')
          .then(response => {
            bus.$emit('hide-loader')
            window.open(response.url, '_blank')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      logarNovoMoodle () {
        bus.$emit('show-loader')
        restfulService.get('usuario', 'novo-moodle-login')
          .then(response => {
            bus.$emit('hide-loader')
            window.open(response.url, '_blank')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      abrirUrlNovaJanela (url) {
        window.open(url, '_blank')
      },
      matriculaOnline () {
        restfulService.get('matricula-online')
          .then(response => {
            if (!response.error) {
              bus.$emit('abrirJanelaMatricula')
            } else {
              swal({title: 'Aviso', html: response.error, type: 'error'})
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="dashboard">
        <div class="banner-prematric" @click="matriculaOnline" v-if="exibeBannerMatricula">
            <div class="banner-prematric-icone">
                <i class="fas fa-graduation-cap fa-4x"></i>
            </div>

            <div class="banner-prematric-conteudo">
                <p>Pré-matrícula Graduação I</p>
                <h3 class="headline text-uppercase">Clique aqui para fazer sua pré-matrícula.</h3>
            </div>
        </div>

        <dashboard-popup />
        <dashboard-video-popup v-if="false"/>
        <dashboard-matricula-online/>
        <dashboard-pre-matriculado-popup/>
        <dashboard-valida-meus-dados-popup/>
        <dashboard-link-form-popup/>
        <dashboard-horarios class="box-horarios"
                            data-intro="Grade de horários do seu curso"
                            data-step="1"/>
        <dashboard-novidades class="box-novidades"
                             data-intro="Novidades da URCAMP"
                             data-step="6"/>
        <dashboard-notas-frequencias class="box-notas-frequencias"
                                     data-intro="Suas disciplinas com frequência e notas"
                                     data-step="2" v-if="!soEnsinoBasico"/>
        <!-- <dashboard-previsao-do-tempo class="box-previsao-tempo"
                                     data-intro="Previsão do tempo na sua cidade"
                                     data-step="7"/> -->
        <dashboard-qualificacao-urcamp class="box-qualificacao-urcamp"
                              data-intro="Cursos Extras para sua qualificação"
                              data-step="7"/>
        <div class="box-links">
            <div class="box-links-content"
                 data-intro="Links úteis para Ensino Híbrido, Moodle, Sistema de Eventos e muito mais"
                 data-step="8">
                <dashboard-box-link title="Webdiário"
                                    v-if="professor"
                                    icon-class="fas fa-chalkboard-teacher"
                                    href="https://webdiario.urcamp.edu.br"
                                    number="link1"/>
                <dashboard-box-link title="Ambientes Virtuais"
                                    icon-class="fas fa-user-graduate"
                                    number="link2"
                                    :click="abrirModalAmbientesVirtuais"/>
                <dashboard-box-link title="Sou I"
                                    icon-class="fas fa-handshake"
                                    href="https://soui.urcamp.edu.br"
                                    number="link4"/>
                <dashboard-box-link title="Frequências e Notas"
                                    icon-class="fab fa-firstdraft"
                                    :to="{name: 'academico.frequencia-notas'}"
                                    number="link5" v-if="!soEnsinoBasico"/>
                <dashboard-box-link title="Boletins e Pareceres"
                                    icon-class="fab fa-firstdraft"
                                    :to="{name: 'academico.boletins-pareceres'}"
                                    number="link6" v-if="soEnsinoBasico"/>
                <dashboard-box-link title="Resoluções Importantes"
                                    icon-class="fas fa-newspaper"
                                    number="link7"
                                    href="https://urcamp.edu.br/documentos?_page=1&search=&startDate=&endDate=&categories%5B%5D=resolucoes"/>
                <dashboard-box-link title="Agenda de Eventos"
                                    icon-class="fas fa-calendar-alt"
                                    number="link8"
                                    href="https://site.urcamp.edu.br/busca/event"/>
                <!--<dashboard-box-link title="Guia Acadêmico"
                                    icon-class="fas fa-newspaper"
                                    number="link1"
                                    href="https://site.urcamp.edu.br/documento/56/guia-academico-2018"
                                    v-if="!soEnsinoBasico"/>-->
                <dashboard-box-link title="Manual TCC"
                                    icon-class="fas fa-book-reader"
                                    number="link2"
                                    href="https://site.urcamp.edu.br/pesquisa-e-extensao/ediurcamp/livros-e-books-e-websites/manual-do-tcc"
                                    v-if="!soEnsinoBasico"/>
            </div>
        </div>
        <v-dialog v-model="mostrarModalEnsinoHibrido" width="80%">
            <v-card class="infofrafico">
                <img src="/static/img/infografico_ensino_hibrido.jpg">
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="mostrarModalEnsinoHibrido = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="mostrarModalAmbientesVirtuais" :width="isMobileSize ? '80%' : '50%'">
          <v-card class="popup-modal">
            <v-container>
              <h3 class="pb-3" :class="{'display-0': isMobileSize, 'display-1': !isMobileSize}">
                Ambientes Virtuais
              </h3>
              <div class="text">
                <div>
                  <h4 class="pb-0 subheading">
                    <strong>PLATAFORMA URCAMP</strong>
                  </h4>
                  <p class="ma-0" :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
                    É o local destinado ao desenvolvimento do ensino e da aprendizagem a distância nos atuais componentes
                    curriculares de seu curso presencial ou digital. O atual Ambiente Virtual de Aprendizagem da Urcamp
                    está disponível a partir do primeiro semestre do ano de 2025 para o ensino presencial e digital.
                  </p>
                  <v-btn color="primary"
                         depressed
                         small
                         :block="isMobileSize"
                         @click="abrirUrlNovaJanela('https://plataforma.urcamp.edu.br')"
                         class="ma-0 mt-2 text-none">
                    Clique aqui para acessar
                  </v-btn>
                </div>

                <v-divider class="my-3"></v-divider>

                <div>
                  <h4 class="pb-0 subheading">
                    <strong>MOODLE</strong>
                  </h4>
                  <p class="ma-0" :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
                    Aqui você acessa os componentes curriculares de seu curso presencial que foram desenvolvidos no
                    Ambiente Virtual de Aprendizagem da Urcamp até o 2º semestre do ano de 2024.
                  </p>
                  <v-btn color="primary"
                         depressed
                         small
                         :block="isMobileSize"
                         @click="abrirUrlNovaJanela('https://virtual.urcamp.edu.br')"
                         class="ma-0 mt-2 text-none">
                    Clique aqui para acessar
                  </v-btn>
                </div>

                <v-divider class="my-3"></v-divider>

                <div>
                  <h4 class="pb-0 subheading">
                    <strong>PLATAFORMA A - EAD</strong>
                  </h4>
                  <p class="ma-0" :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
                    Aqui você acessa os componentes curriculares de seu curso EAD que foram desenvolvidos no Ambiente
                    Virtual de Aprendizagem da Urcamp até o 2º semestre do ano de 2024.
                  </p>
                  <v-btn color="primary"
                         depressed
                         small
                         :block="isMobileSize"
                         @click="abrirUrlNovaJanela('https://urcamp.grupoa.education/plataforma/auth/signin?returnUrl=%2F')"
                         class="ma-0 mt-2 text-none">
                    Clique aqui para acessar
                  </v-btn>
                </div>
              </div>
            </v-container>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="mostrarModalAmbientesVirtuais = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>
<style lang="scss">

    .introjs-helperNumberLayer {
        left: 10px !important;
        top: -25px !important;
    }

    .step-tooltip {
        max-width: none !important;
        .introjs-tooltiptext {
            font-size: 18px;
            font-family: Ubuntu, 'Sans-serif';
            padding: 10px;
            font-weight: 300;
        }
        .introjs-tooltipbuttons {
            a {
                border: none;
                font-size: 14px;
                text-shadow: none;
            }
        }
    }

    .infofrafico {
        padding: 20px;
        img {
            display: block;
            max-width: 100%;
            margin: 0 auto;
        }
    }

    .dashboard {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -4px -16px;
        max-width: 100%;
        position: relative;

        .box {
            margin: 0 8px 16px;

            .box-content {
                min-height: calc(100% - 30px);
                display: flex;
                justify-content: center;
                align-items: flex-start;

                .v-tabs__items,
                .box-content-full {
                    width: 100%;
                }
                .box-content-full,
                .box-content-vazio {
                    margin: 0 auto;
                }

                .box-content-vazio {
                    text-align: center;
                    flex: 1 0 100%;

                    &.-menor {
                        h3 {
                            font-size: 16px;
                        }
                        .icon-vazio {
                            font-size: 38px;
                        }
                    }
                    h3 {
                        font-size: 22px;
                        font-weight: 400;
                        color: #4e4e4e;
                    }
                    .icon-vazio {
                        color: rgba(223, 146, 72, 0.49);
                        font-size: 48px;
                    }
                }
            }

            &.avaliacao-ensino-hibrido {
                .box-header {
                    background-color: rgba(190, 38, 38, 0.15);
                    border-bottom: 1px solid #be2626;
                    justify-content: center;
                    .box-title {
                        color: #be2626;
                    }
                }
                .box-content {
                    text-align: center;
                    font-size: 16px;
                }
            }
        }

        .box.box-10 {
            width: calc(14.2% - 16px);
        }

        .box.box-25 {
            width: calc(25% - 16px);
        }

        .box.box-50 {
            width: calc(50% - 16px);
        }

        .box.box-75 {
            width: calc(75% - 16px);
        }
        .box.box-100 {
            width: calc(100% - 16px);
        }
        .box-links {
            width: 100%;
            order: 10;
            .box-links-content {
                display: flex;
                flex-wrap: wrap;
                margin: 0 0 -16px;
                .box {
                    margin: 0 10.5px 10px;
                }
            }
        }

        .box-link.link1 > .link-content > div .icon svg path {
            fill: #cb9a79;
        }

        .box-link.link1:hover {
            background: linear-gradient(145deg, #FFC79E, #cb9a79, #FFC79E, #cb9a79);
            background-size: 400% 400%;
        }

        .box-link.link2 > .link-content > div .icon svg path {
            fill: #4FB053;
        }

        .box-link.link2:hover {
            background: linear-gradient(145deg, #4FB053, #76cde7, #4FB053, #76cde7);
            background-size: 400% 400%;
        }

        .box-link.link3 > .link-content > div .icon svg path {
            fill: #f0820c;
        }

        .box-link.link3:hover {
            background: linear-gradient(-145deg, #f0820c, #b3756d, #f0820c, #b3756d);
            background-size: 400% 400%;
        }

        .box-link.link4 > .link-content > div .icon svg path {
            fill: #11A5FC;
        }

        .box-link.link4:hover {
            background: linear-gradient(-145deg, #11A5FC, #e89898, #11A5FC, #e89898);
            background-size: 400% 400%;
        }

        .box-link.link5 > .link-content > div .icon svg path {
            fill: #773f96;
        }

        .box-link.link5:hover {
            background: linear-gradient(145deg, #773f96, #a799e7, #773f96, #a799e7);
            background-size: 400% 400%;
        }

        .box-link.link6 > .link-content > div .icon svg path {
            fill: #73966a;
        }

        .box-link.link6:hover {
            background: linear-gradient(145deg, #809646, #73966a, #809646, #73966a);
            background-size: 400% 400%;
        }

        .box-link.link7 > .link-content > div .icon svg path {
            fill: #098496;
        }

        .box-link.link7:hover {
            background: linear-gradient(145deg, #07606e, #098496, #07606e, #098496);
            background-size: 400% 400%;
        }

        .box-link.link8 > .link-content > div .icon svg path {
            fill: #098496;
        }

        .box-link.link8:hover {
            background: linear-gradient(145deg, #0fcc7b, #33a863, #07b7e8, #38aa94);
            background-size: 400% 400%;
        }

        @-webkit-keyframes Gradient {
            0% {
                background-position: 0% 50%;
            }

            50% {
                background-position: 100% 50%;
            }

            100% {
                background-position: 0% 50%;
            }
        }

        @keyframes Gradient {
            0% {
                background-position: 0% 50%;
            }

            50% {
                background-position: 100% 50%;
            }

            100% {
                background-position: 0% 50%;
            }
        }

        .dashboard-table {
            border-collapse: collapse;
            width: 100%;
            thead {
                tr {
                    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                    th {
                        padding: 6px 24px;
                        color: #8c8c8c;
                        text-align: left;
                        font-size: 11px;
                    }
                }
            }
            tbody {
                tr {
                    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
                    transition: all .3s ease-in-out;
                    &:last-child {
                        border-bottom: none;
                    }
                    &:hover {
                        background-color: #f1f1f2;
                    }
                    td {
                        padding: 3px 20px;
                        font-size: 12px;
                        height: 36px;
                        letter-spacing: -0.02em;
                    }
                }
            }
            th, td {
                &.horario {
                    padding-left: 6px;
                    padding-right: 6px;
                }
            }
        }
    }

    .banner-prematric {
        background: linear-gradient(145deg, #468846, #60a6bf, #438844, #60a5bf);
        background-size: 800% 800%;
        border-radius: 16px;
        color: #fff;
        width: 100%;
        margin: 0 8px 16px 8px;
        padding: 32px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all .4s ease-in-out;
        animation: Gradient 30s ease infinite;

        &-icone {
        }

        &-conteudo {
            padding-left: 24px;

            p {
                margin: 0;
            }
        }
    }

    @media all and (max-width: 1780px) {
        .dashboard {
            .box.box-10 {
                width: 15%;
            }
        }
    }

    @media all and (max-width: 1280px) {
        .dashboard {
            justify-content: space-between;
            .box {
                margin: 0 0 15px;
                .link-content > div .link-text {
                    font-size: 16px !important;
                    font-weight: 500;
                    line-height: 27px;
                }
            }
            .box.box-75 {
                width: 100%;
            }
            .box.box-25 {
                width: 49%;
            }
            .box.box-10 {
                width: 23%;
            }

            .box-horarios {
                order: 1;
            }
            .box-notas-frequencias {
                order: 2;
            }
            .box-novidades {
                order: 3;
            }
            /*.box-previsao-tempo {
                order: 4;
            }*/
            .box-qualificacao-urcamp {
                order: 4;
            }
            .box-links {
                .box-links-content {
                    .box {
                        margin-bottom: 16px;
                    }
                }
            }
        }
    }

    @media all and (max-width: 1024px) {
        .dashboard {
            .box.box-10 {
                width: 15%;
                .link-content > div .link-text {
                    font-size: 16px;
                }
            }
        }
    }

    @media all and (max-width: 768px) {
        .banner-prematric {
            flex-direction: column;
            justify-content: center;
            text-align: center;
            margin-left: 0;
            margin-right: 0;

            &-icone {
            }

            &-conteudo {
                padding-left: 0;
                padding-top: 16px;

                p {
                    margin: 0;
                }
            }
        }

        .dashboard {
            margin: 0;

            .box-links-content {
                margin: 0 -7px !important;
            }
            .box {
                width: 100% !important;
                margin: 0 0 15px 0;

                &.box-10 {
                    width: 30.5% !important;
                }
                .box-content {
                    min-height: 30vh;
                }
            }
        }
    }

    @media all and (max-width: 560px) {
        .dashboard {
            .box {

                &.box-10 {
                    width: 45.4% !important;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?5da7f6a2